import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChatApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  public getUserChatData(): Observable<Record<string, unknown>> {
    return this.httpClient.get<Record<string, unknown>>(this.rmaApiUrl('Chat/Data'));
  }
}
